
import { Component, Vue, Prop } from "vue-property-decorator";

import Monitor from "./Monitor.vue";
import UnfollowPatents from "./UnfollowPatents.vue";
import FeeStandard from "./subviews/FeeStandard.vue";
import MyPatentOperationList from "./subviews/MyPatentOperationList.vue";

import { isEmptyOrWhiteSpace } from "@/utils/Common";
import isFunction from "lodash/isFunction";
import { CreateElement } from "vue";

@Component({ components: { Monitor, UnfollowPatents, FeeStandard, MyPatentOperationList } })
export default class SubList extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  listProps!: Dict;

  @Prop({ type: String, required: true })
  componentName!: string;

  handleEvent() {
    this.$emit("load-tree");
  }

  reloadData() {
    const subList: any = this.$refs.comp;
    if (subList === undefined) {
      return;
    }
    if (isFunction(subList.searchData)) {
      subList.searchData();
    }
  }

  render(createElement: CreateElement) {
    if (isEmptyOrWhiteSpace(this.componentName)) {
      return createElement("div", "");
    }
    return createElement(this.componentName, {
      props: {
        ...this.listProps
      },
      on: {
        "load-tree": this.handleEvent
      },
      key: this.componentName,
      ref: "comp"
    });
  }
}
